import { object } from "superstruct";

import GiftRegistryWithRegistrantSchema from "./GiftRegistryWithRegistrantSchema";

const CreateGiftRegistryResponseSchema = object({
    giftRegistryWithRegistrant: GiftRegistryWithRegistrantSchema,
});

export default CreateGiftRegistryResponseSchema;
